import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=34cb0984&scoped=true"
import script from "./dashboard.ts?vue&type=script&lang=js&external"
export * from "./dashboard.ts?vue&type=script&lang=js&external"
import style0 from "./dashboard.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./dashboard.scss?vue&type=style&index=1&id=34cb0984&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cb0984",
  null
  
)

export default component.exports